// extracted by mini-css-extract-plugin
export default {"Menu":"menu_Menu_e0H46"};